import { accessToken } from '../Auth0/react-auth0-spa';


export interface IInvokeApiRequest {
    path: string;
    method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
    responseType?: 'json' | 'text' | 'blob' | 'text';
    body?: any;
    headers?: Array<{ name: string, value: string }>;
}

export async function invokeApi(request: IInvokeApiRequest) {
    console.log('invokeApi path', request.path);
    const url = request.path;

    // if (request.path === '/api/Contact/auth0|640063b2f248b654371e887b/MedicalExamination/admin/document'){
    //     throw {message: '413 Request Entity Too Large'};
    // }

    const headers: Headers = new Headers();
    const idToken = await accessToken;

    if (request.body)
        headers.append("Content-Type", "application/json");

    if (idToken)
        headers.append("Authorization", `Bearer ${idToken}`);

    if (request.headers)
        request.headers.forEach(h => headers.append(h.name, h.value))

    request.body = (request.body) ? JSON.stringify(request.body) : request.body;

    const reqInfo = {
        method: request.method,
        body: request.body,
        headers: headers
    };

    const results = await fetch(url, reqInfo);

    console.log('invokeApi result', results);

    if (results.status === 409) {
        const a = await results.json();
        throw a;
    }
    else if (results.status === 404) {
        const a = await results.json();
        throw a;
    }
    else if (results.status === 413) {
        throw {message: '413 - Dimensione file troppo grande'};
    }
    // if (Status Code: 500 Internal Server Error)

    if (request.responseType === 'blob')
        return results
    else if (request.responseType === 'json') {
        try {
            return results.json();
        }
        catch (ex) {
            console.log(ex);
            throw ex;
        }
    }
    else if (request.responseType === 'text') {
        try {
            return results.text();
        }
        catch (ex) {
            console.log(ex);
            throw ex;
        }
    }
    else {
        return results
    }

}